// API Configuration for Fire Bridge

// Network constants
const NETWORK_CONSTANTS = {
  LOCALHOST: 'localhost',
  LOCALHOST_IP: '127.0.0.1',
  RASPBERRY_PI_HOSTNAME: 'raspberrypi',
  PRIVATE_NETWORK_PREFIX: '192.168.',
  FALLBACK_IP: '192.168.114.244',
  API_PORT: '9000',
  PROTOCOL: 'http',
};

/**
 * Get the default base URL for the API
 * @returns {string} The default base URL for the API
 */
const getDefaultBaseUrl = () => {
  const { hostname } = window.location;
  console.log('Hostname: ', hostname);
  
  // If running on the same host as the API (like on Pi), use localhost
  if (hostname === NETWORK_CONSTANTS.LOCALHOST || hostname === NETWORK_CONSTANTS.LOCALHOST_IP) {
    return `${NETWORK_CONSTANTS.PROTOCOL}://${NETWORK_CONSTANTS.LOCALHOST}:${NETWORK_CONSTANTS.API_PORT}`;
  }
  
  // If running on Pi or same network, use the current host with API port
  if (hostname.startsWith(NETWORK_CONSTANTS.PRIVATE_NETWORK_PREFIX) || 
      hostname.includes(NETWORK_CONSTANTS.RASPBERRY_PI_HOSTNAME)) {
    return `${NETWORK_CONSTANTS.PROTOCOL}://${hostname}:${NETWORK_CONSTANTS.API_PORT}`;
  }
  
  // Fallback to hardcoded IP for development
  return `${NETWORK_CONSTANTS.PROTOCOL}://${NETWORK_CONSTANTS.FALLBACK_IP}:${NETWORK_CONSTANTS.API_PORT}`;
};

export const API_CONFIG = {
  // Dynamic base URL that adapts to the deployment environment
  BASE_URL: process.env.REACT_APP_FIRE_BRIDGE_BASE_URL || getDefaultBaseUrl(),
  
  // Polling interval in milliseconds (default: 5 seconds)
  POLLING_INTERVAL: parseInt(process.env.REACT_APP_POLLING_INTERVAL_MS) || 5000,
  
  // API timeout in milliseconds (default: 10 seconds) - increased for Pi
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT_MS) || 15000,
  
  // Retry configuration - more aggressive for Pi
  MAX_RETRIES: 5,
  RETRY_DELAY: 2000, // 2 second delay between retries
};

export default API_CONFIG;
